import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { PatientPharmacyId } from '@app/icare/entities/patient/schema/PatientPharmacy'
import { PatientPharmacyOverview } from '@app/icare/routes/_app/patienten/$id/_edit/_pharmacy/-components/PatientPharmacyOverview'
import { entityParams } from '@pkg/db/utils'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_pharmacy/apotheken/$relation')({
  params: entityParams({ id: PatientId, relation: PatientPharmacyId }),
  component: RouteComponent,
})

function RouteComponent() {
  const { id, relation } = Route.useParams()

  return <PatientPharmacyOverview patientId={id} relationId={relation} />
}
